module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABJklEQVQ4T62TDU1DQRCEv3FQCTgAFFAJ4KAogCqAKqA4qAMqoShocYCEOhgyL3d0+1IgAS55ebmf3Z2ZnRWjZfsMuAMWkva5tj0BHoBnSe81RHVjewlcABvgGnhp9zfAGpgCW0nzHveZwPYswZLuS9UEZG0KmlXb509NkMdTSY9jWidQriUF5VGCIJhICo0vl+0g3Es6ILCd6gkMgi5ckFwVCotCLdXvg0K2d0C+HNTgiJkkOUvyXafXujIIngQRqIs1FMwZMOsts51ky1Pv/iVB4G+B+YjCeczUKDwBbyMKObsc2viNiNUHQ3sb/4OIvV/NSL9rY0HxZyONrdx98PqjlRuKPkwZots2QLnqgxVNIuYwL0dWLlpknGPr9L2Oc4JW43H+AGa1xSUzms1rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/setup1.png
// module id = 3oWc
// module chunks = 1